<template>
  <div>
    <el-dialog
      title="新增种类"
      :visible.sync="showFlag"
      width="30%"
      center
      :close-on-click-modal="false"
      :before-close="closeModal"
    >
      <div class="Form">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          class="demo-ruleForm"
        >
          <el-form-item label="" prop="cropName">
            <el-input
              v-model="ruleForm.cropName"
              class="product_input"
              maxlength="20"
              placeholder="请输入种类名称"
            ></el-input>
            <p class="tips">Tips：新增种类须通过审核后才能使用。</p>
          </el-form-item>
          <div class="submit_wrap">
            <el-button type="primary" @click="submitForm('ruleForm')"
              >保 存</el-button
            >
          </div>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getStorage } from "@/utils/storage";
import { cropService } from "@/api/request/snkd.produce";
export default {
  props: {
    showFlag: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      companyId: "",
      farmId: "",
      ruleForm: {
        cropName: "",
      },
      rules: {
        cropName: [
          { required: true, message: "请输入种类名称", trigger: "blur" },
        ],
      },
    };
  },
  mounted() {
    //获取农场id
    const farminfo = getStorage("FARMINFO");
    if (getStorage("FARMINFO")) {
      this.companyId = farminfo.companyId;
      this.farmId = farminfo.farmId;
    }
  },
  methods: {
    async saveForm() {
      let params = {
        ...this.ruleForm,
        companyId: this.companyId,
        farmId: this.farmId,
      };
      try {
        await cropService.addFeedback(params);
        this.$message({
          message: "已提交，审核结果将以短信形式通知您，请耐心等候",
          type: "success",
        });
        this.$emit("update:showFlag", false);
        this.$emit("updateCropList");
        this.resetForm();
      } catch (error) {
        console.log(error);
      }
    },
    //关闭弹窗
    closeModal() {
      this.$emit("update:showFlag", false);
      this.resetForm();
    },
    //重置表单
    resetForm() {
      this.$refs.ruleForm.resetFields();
    },
    //表单提交
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.saveForm();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.submit_wrap {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  button {
    margin-top: 20px;
    width: 110px;
  }
}
.el-select {
  width: 100%;
}
.tips {
  text-indent: 0;
  color: #9fa0a0;
  font-size: 14px;
  line-height: 22px;
  margin-top: 8px;
}
</style>
